import React, { useContext, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { InfoBox } from 'components/message-boxes/information-box/InformationBox'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import updateApplicationServices from 'services/updateApplicationServices'
import { IUpdatePreliminaryIdentificationRequest } from 'interfaces/i-update-application'
import { getAuthTimeFromClaims, getIdpFromClaims } from 'utils/authHelpers'
import getApplicationServices from 'services/getApplicationServices'
import documentServices from 'services/documentServices'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'

const PreliminaryIdentification = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext
	)

	const applicationId = loanApplication.applicationData?.loanNumber!
	const { msp, dispatchMsp } = useContext(MspDispatchContext)

	const isMissingPreliminaryIdentification = () => {
		return loanApplication.applicationData?.isCoApplicant
			? !loanApplication.applicationData?.preliminaryIdentification
					?.coapplicant?.idMethod
			: !loanApplication.applicationData?.preliminaryIdentification
					?.applicant?.idMethod
	}

	const getIdentificationData = async () => {
		const idp = await getIdpFromClaims()
		const authTime = await getAuthTimeFromClaims()
		const identData: IUpdatePreliminaryIdentificationRequest = {
			applicationId: applicationId,
			isCoapplicant: loanApplication.applicationData?.isCoApplicant!,
			idMethod: 'FTN-' + idp,
			timestamp: new Date(Number(authTime) * 1000),
			generatePromissoryNote: true,
		}
		return identData
	}

	useEffect(
		() => {
			if (!isMissingPreliminaryIdentification()) {
				if (
					loanApplication.applicationData?.lifeCycleStatus ===
					LifeCycleStatus.ApplicationReceived
				) {
					dispatchMsp({
						type: MSP_ACTIONS.SET_INDEX,
						payload: {
							index: msp.index + 1,
						},
					})
				} else {
					dispatchMsp({
						type: MSP_ACTIONS.RESET_STEPS,
					})
				}
			}
		},
		[loanApplication] //eslint-disable-line
	)

	const getApplicationInformation = async (applicationId: number) => {
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
			await documentServices
				.getDownloadDocuments(applicationId.toString(), t)
				.then((response) => {
					loanApplication.setDocumentData(response)
				})
		} catch (error) {
			console.warn(error)
		}
	}

	useEffect(
		() => {
			if (isMissingPreliminaryIdentification()) {
				getIdentificationData().then((identificationData) =>
					updateApplicationServices
						.updatePreliminaryIdentification(identificationData, t)
						.then(async () => {
							await getApplicationInformation(
								applicationId
							).then()
						})
				)
			}
			return () => {}
		},
		[] //eslint-disable-line
	)

	return (
		<div className="preliminaryIdentification">
			<InfoBox
				infoType="info"
				message={
					<div className="info-message">
						<Trans
							t={t}
							i18nKey="IdentificationDescription"></Trans>
					</div>
				}
			/>
			<div className="col-spinner mt-5">
				<CircleSpinner />
			</div>
		</div>
	)
}

export default PreliminaryIdentification
